import { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const promos = [
    "Clear Skin Starts Today – Try Our Acne Patches!",
    "Free Shipping on All Orders !",
    "Overnight Pimple Fix – Gentle & Effective",
    "Join the Clear Skin Club – Shop Now!",
  ];

export default function PromoNavbar() {
  const [index, setIndex] = useState(0);

  const prev = () => {
    setIndex((index - 1 + promos.length) % promos.length);
  };

  const next = () => {
    setIndex((index + 1) % promos.length);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % promos.length);
    }, 1000); // change every 4 seconds

    return () => clearInterval(interval); // cleanup on unmount
  }, []);

  return (
    <div className="bg-black text-white py-1">
      <div className="mainnav max-w-7xl mx-auto flex items-center justify-center gap-6">
        <button
          onClick={prev}
          className="bg-white text-black rounded-full shadow hover:bg-gray-100"
        >
          <ChevronLeft size={20} />
        </button>
        <span className="text-xs md:text-lg font-medium text-center">
          {promos[index]}
        </span>
        <button
          onClick={next}
          className="bg-white text-black rounded-full shadow hover:bg-gray-100"
        >
          <ChevronRight size={20} />
        </button>
      </div>
    </div>
  );
}
